import { makeStyles } from '@mui/styles';
import styled from 'styled-components';

export const Header = styled.div`
  height: auto;
  width: auto;
  background-color: ${({ theme }) => theme.white};
  > img{
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
  }
`;

export const Footer = styled.div`
  height: auto;
  width: auto;
  background-color: ${({ theme }) => theme.white};
  > img{
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
  }
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: ${({ theme }) => theme.white};
  width: 100%;
  max-width: 600px;
  height: 400px;
  color: ${({ theme }) => theme.pantoneBlack};
  padding: 1rem 3rem;
  gap: 1rem;
`;

export const Title = styled.h1`
  text-align: center;
  color: ${({ theme }) => theme.pantoneBlack};
  max-width: 400px;
  font-size: 1.425rem;
  font-weight: bold;
`;

export const Paragraph = styled.p`
  text-align: left;
  text-justify: auto;
  color: ${({ theme }) => theme.pantoneBlack};
`;

export const BoxForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
  margin: auto;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 0 auto;
  }
`;

export const Background = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.pantone656C};
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
  min-height: 100vh;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    justify-content: flex-start;
  }
`;
